/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form } from 'antd'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import HouseholdSelect from '../../../../components/Custom/HouseholdSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form, AuthStore, fromHousehold, onSelectedHousehold } = this.props
		const { getFieldDecorator, setFieldsValue, resetFields } = form
		const { barangay_uid } = AuthStore
        
		return (
			<Row gutter={16}>
				<Col md={4} sm={24}>
					<Form.Item label='Household No.'>
						{ getFieldDecorator('household_uid', {
							rules: [{
								required: true,
								message: 'This field is required.'
							}]
						})
						(
							<HouseholdSelect 
								disabled={(fromHousehold)}
								barangay_uid={barangay_uid}
								onSelectedItem={(item) => {
									onSelectedHousehold(item)
									if (item) {
										setFieldsValue({
											house_no: item.house_no,
											street: item.street,
											address: item.address,
											purok_name: item.purok_name
										})
									} else {
										resetFields(['house_no','street','address','purok_name'])
									}
								}}
							/>
						)}
					</Form.Item>
				</Col>
				<Col md={4} sm={24}>
					<Form.Item label='House No.'>
						{ getFieldDecorator('house_no', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input placeholder='House number'/>
						)}
					</Form.Item>
				</Col>
				<Col md={2} sm={24}>
					<Form.Item label='Block No.'>
						{ getFieldDecorator('block', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input placeholder='Block Number'/>
						)}
					</Form.Item>
				</Col>
				<Col md={2} sm={24}>
					<Form.Item label='Lot'>
						{ getFieldDecorator('lot', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input placeholder='Lot Number'/>
						)}
					</Form.Item>
				</Col>
				<Col md={4} sm={24}>
					<Form.Item label='Street'>
						{ getFieldDecorator('street', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input placeholder='Street'/>
						)}
					</Form.Item>
				</Col>
				<Col md={4} sm={24}>
					<Form.Item label='Sitio/Subdivision'>
						{ getFieldDecorator('address', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input placeholder='Sitio/Subdivision'/>
						)}
					</Form.Item>
				</Col>
				<Col md={4} sm={24}>
					<Form.Item label='Purok'>
						{ getFieldDecorator('purok_name', {
							rules: [{
								required: false,
								message: 'This field is required.'
							}]
						})
						(
							<Input disabled placeholder='Purok Name'/>
						)}
					</Form.Item>
				</Col>
			</Row>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
